import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { ApplicationsPanel } from "@/components/admin/ApplicationsPanel";
import { ModelsPanel } from "@/components/admin/ModelsPanel";
import { AgentsPanel } from "@/components/admin/AgentsPanel";
import { StatsPanel } from "@/components/admin/StatsPanel";
import { ExampleVideoPanel } from "@/components/admin/ExampleVideoPanel";
import { BannerPanel } from "@/components/admin/BannerPanel";
import { TemplatesPanel } from "@/components/admin/TemplatesPanel";

const TABS = [["applications", "Candidature"], ["models", "Modelle"], ["agents", "Agenti"], ["stats", "Statistiche"], ["video", "Video esempio"], ["banner", "Banner"], ["contracts", "Contratti"]];
const PANELS = { applications: ApplicationsPanel, models: ModelsPanel, agents: AgentsPanel, stats: StatsPanel, video: ExampleVideoPanel, banner: BannerPanel, contracts: TemplatesPanel };

export const StaffOnly = ({ user, logout }) => (
  <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-white px-5 text-center text-[#1c1418]">
    <p className="font-display text-5xl uppercase">Area riservata all'admin</p>
    <p className="font-mono text-xs uppercase tracking-[0.2em]">Sei collegata come {user.email}</p>
    <div className="flex gap-3">
      <Link to="/scout" className="bg-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white">Vai all'area agente</Link>
      <button onClick={logout} className="border border-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em]">Esci</button>
    </div>
  </main>
);

export default function Admin() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("applications");
  const Panel = PANELS[tab];

  if (user === null) return <main className="min-h-screen bg-white" />;
  if (!user) return <AdminLogin />;
  if (user.role !== "admin") return <StaffOnly user={user} logout={logout} />;

  return (
    <main data-testid="admin-dashboard" className="min-h-screen bg-white px-5 pb-24 pt-28 text-[#1c1418] md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-4 border-b-2 border-[#1c1418] pb-4">
          <h1 className="font-display text-6xl uppercase leading-none md:text-8xl">Pannello<span className="text-[#1c1418]">.</span></h1>
          <button onClick={logout} data-testid="admin-logout-button" className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] hover:text-[#1c1418]/60"><LogOut className="h-4 w-4" /> Esci</button>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-6">
          {TABS.map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}
              className={`font-display text-3xl uppercase transition-colors ${tab === k ? "text-[#1c1418] underline decoration-[#e9458f] decoration-4 underline-offset-8" : "text-[#1c1418]/40 hover:text-[#1c1418]"}`}>{l}</button>
          ))}
          <Link to="/compcard" data-testid="admin-compcard-link" className="font-display text-3xl uppercase text-[#1c1418]/40 hover:text-[#1c1418]">Compcard ↗</Link>
        </div>
        <div className="mt-8"><Panel /></div>
      </div>
    </main>
  );
}
